/**
 * Auth Store
 * Tracks FastAdmin login status — mirrors the server-side session state
 * on the client so the UI can react to login/logout without a page reload.
 */

import { create } from 'zustand';
import { useUserProfileStore } from './user-profile';

export interface AuthState {
  loggedIn: boolean;
  nickname: string;
  username: string;
  checked: boolean;
  fetchStatus: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  loggedIn: false,
  nickname: '',
  username: '',
  checked: false,

  fetchStatus: async () => {
    try {
      const res = await fetch('/api/auth/status', { cache: 'no-store' });
      const data = await res.json() as { success: boolean; loggedIn: boolean; nickname?: string; username?: string };

      // Sync nickname from FastAdmin to local profile store so GreetingBar can display it
      if (data.loggedIn && data.nickname) {
        useUserProfileStore.getState().setNickname(data.nickname);
      }

      set({
        loggedIn: data.loggedIn ?? false,
        nickname: data.nickname ?? '',
        username: data.username ?? '',
        checked: true,
      });
    } catch {
      set({ loggedIn: false, checked: true });
    }
  },
}));
